import script from "./BaseColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./BaseColorPicker.vue?vue&type=style&index=0&id=aeedac72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeedac72"]])

export default __exports__